// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-7653fc8a]:root {
  font-size: clamp(13px + 2 * (100vw - 1440px) / 480, 1vw, 16px + 2 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-7653fc8a]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-7653fc8a]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-7653fc8a]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
header[data-v-7653fc8a] {
  width: 100%;
  position: absolute;
  padding: 0.8rem calc(var(--size) + 2vw);
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
}
@media screen and (min-width: 1024px) {
header.active[data-v-7653fc8a] {
    position: fixed;
    background: #f9fefb;
    padding: 0.64rem calc(var(--size) + 2vw);
    transform: translateY(-100%);
    animation: viewHeader-7653fc8a 400ms cubic-bezier(0.65, 0, 0.35, 1) forwards;
}
@keyframes viewHeader-7653fc8a {
0% {
      transform: translateY(-100%);
}
100% {
      transform: translateY(0);
}
}
header.active .logo[data-v-7653fc8a] {
    width: 9rem;
    transform: translateY(0.72rem) scale(1.2);
    animation: logoScale-7653fc8a 400ms 200ms cubic-bezier(0.65, 0, 0.35, 1) forwards;
}
@keyframes logoScale-7653fc8a {
0% {
      transform: translateY(0.72rem) scale(1);
}
100% {
      transform: translateY(0.72rem) scale(1.2);
}
}
header.active nav[data-v-7653fc8a] {
    left: 50%;
    transform: translate(-50%, -50%);
}
}
header[data-v-7653fc8a] > * {
  align-self: center;
}
header .logo[data-v-7653fc8a] {
  width: 10rem;
  justify-self: flex-start;
  transform: translateY(0.8rem) scale(1.1);
}
@media screen and (max-width: 1023px) {
header .logo[data-v-7653fc8a] {
    width: 8.8rem;
    transform: translateY(0.4rem);
}
}
header .logo img[data-v-7653fc8a] {
  width: 100%;
}
header .trg[data-v-7653fc8a] {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 50%;
  background: #00a199;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
@media screen and (min-width: calc(769px + 1px)) {
header .trg[data-v-7653fc8a] {
    display: none !important;
}
}
header .trg svg[data-v-7653fc8a] {
  width: 2rem;
  fill: #f9fefb;
}
header nav[data-v-7653fc8a] {
  position: absolute;
  top: 50%;
  left: 18rem;
  transform: translateY(-50%);
}
@media screen and (max-width: 1023px) {
header nav[data-v-7653fc8a] {
    left: calc(50% - 1.2rem);
    transform: translate(-50%, -50%);
}
}
@media screen and (min-width: calc(769px + 1px)) {
header nav[data-v-7653fc8a] {
    display: block !important;
    opacity: 1 !important;
}
}
@media screen and (max-width: 769px) {
header nav[data-v-7653fc8a] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transform: translate(0);
    background: #f9fefb;
    padding: var(--head) 0 0;
    z-index: -1;
    box-shadow: 0 0 3.2rem rgba(32, 43, 43, 0.12);
}
}
header nav ul[data-v-7653fc8a] {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 769px) {
header nav ul[data-v-7653fc8a] {
    padding: 2rem 0 0;
    display: block;
}
}
header nav ul li[data-v-7653fc8a] {
  margin: 0 0 0 2.8rem;
  font-weight: 500;
}
@media screen and (max-width: 1023px) {
header nav ul li[data-v-7653fc8a] {
    margin: 0 0 0 2.4rem;
    font-size: 0.96rem;
}
}
@media screen and (max-width: 769px) {
header nav ul li[data-v-7653fc8a] {
    margin: 0;
    border-bottom: rgba(32, 43, 43, 0.08) 1px solid;
}
header nav ul li[data-v-7653fc8a]:last-child {
    border: none;
}
}
header nav ul li.spv[data-v-7653fc8a] {
  display: none;
}
@media screen and (max-width: 769px) {
header nav ul li.spv[data-v-7653fc8a] {
    display: block;
}
}
@media screen and (max-width: 769px) {
header nav ul li a[data-v-7653fc8a] {
    padding: 1.12rem calc(var(--size) + 2vw);
    display: block;
    font-size: 1.12rem;
    position: relative;
}
}
header nav ul li a.active[data-v-7653fc8a], header nav ul li a[data-v-7653fc8a]:hover {
  color: #00a199;
}
header nav ul li a svg[data-v-7653fc8a] {
  display: none;
}
@media screen and (max-width: 769px) {
header nav ul li a svg[data-v-7653fc8a] {
    display: block;
    position: absolute;
    top: 50%;
    right: calc(var(--size) + 2vw);
    transform: translateY(-50%);
    width: 1.72rem;
    fill: #202b2b;
    opacity: 0.32;
}
}
header nav ul li[data-v-7653fc8a]:first-child {
  margin: 0;
}
header .btn[data-v-7653fc8a] {
  justify-self: flex-end;
  color: #f9fefb;
  border: #00a199 1px solid;
  font-size: 1.08rem;
  line-height: 1.5;
  padding: 0.8rem 3.2rem;
  border-radius: 999rem;
  overflow: hidden;
  position: relative;
  display: inline-flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: color 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .btn[data-v-7653fc8a]:before {
  content: "";
  background: #00a199;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  transition: width 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .btn svg[data-v-7653fc8a] {
  position: relative;
  display: inline-block;
  width: 1.4rem;
  transform: translateX(0.64rem);
  fill: #f9fefb;
  height: auto;
}
header .btn[data-v-7653fc8a]:hover {
  color: #00a199;
}
header .btn:hover svg[data-v-7653fc8a] {
  fill: #00a199;
}
header .btn[data-v-7653fc8a]:hover:before {
  left: auto;
  right: 0;
  width: 0;
}
@media screen and (max-width: 1023px) {
header .btn[data-v-7653fc8a] {
    padding: 0.88rem 2.4rem;
}
}
@media screen and (max-width: 769px) {
header .btn[data-v-7653fc8a] {
    display: none;
}
}
header .fade-enter-active[data-v-7653fc8a],
header .fade-leave-active[data-v-7653fc8a] {
  transition: opacity 0.4s cubic-bezier(0.65, 0, 0.35, 1);
}
header .fade-enter-from[data-v-7653fc8a],
header .fade-leave-to[data-v-7653fc8a] {
  opacity: 0;
}
header #overlay[data-v-7653fc8a] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -2;
  background: rgba(32, 43, 43, 0.8);
  width: 100%;
  height: 100%;
}
@media screen and (min-width: calc(769px + 1px)) {
header #overlay[data-v-7653fc8a] {
    display: none !important;
}
}`, "",{"version":3,"sources":["webpack://./src/scss/module/_module.scss","webpack://./headers.vue","webpack://./src/js/components/headers.vue"],"names":[],"mappings":"AAEA;6DAAA;AAeA;6DAAA;AAOA;6DAAA;AAEA;EACC,2FAAA;EAKC,OAAA;EACD,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ACtBF;ADuBC;AAZD;IAaE,eAAA;ACpBA;AACF;ADqBC;AAfD;IAgBE,eAAA;IACE,YAAA;AClBF;AACF;ADmBC;AAnBD;IAoBE,iBAAA;IACE,YAAA;AChBF;AACF;AD0HA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACvHD;ADyHA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ACvHD;AC7DA;EACE,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;AD+DF;AC7DI;AADF;IAEI,eAAA;IACA,mBFLE;IEMF,wCAAA;IACA,4BAAA;IACA,4EAAA;ADgEJ;AC/DI;AACE;MACE,4BAAA;ADiEN;AC/DI;MACE,wBAAA;ADiEN;AACF;AC/DI;IACE,WAAA;IACA,yCAAA;IACA,iFAAA;ADiEN;AChEM;AACE;MACE,uCAAA;ADkER;AChEM;MACE,yCAAA;ADkER;AACF;AC/DI;IACE,SAAA;IACA,gCAAA;ADiEN;AACF;AC9DE;EACE,kBAAA;ADgEJ;AC9DE;EACE,YAAA;EACA,wBAAA;EACA,wCAAA;ADgEJ;AC/DI;AAJF;IAKI,aAAA;IACA,6BAAA;ADkEJ;AACF;ACjEI;EACE,WAAA;ADmEN;AChEE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBFtDG;EAyCN,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EEYE,mBAAA;EACA,uBAAA;EACA,eAAA;ADqEJ;ACpEI;AAZF;IAaI,wBAAA;ADuEJ;AACF;ACtEI;EACE,WAAA;EACA,aFpEE;AC4IR;ACrEE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;ADuEJ;ACtEI;AALF;IAMI,wBAAA;IACA,gCAAA;ADyEJ;AACF;ACxEI;AATF;IAUI,yBAAA;IACA,qBAAA;AD2EJ;AACF;AC1EI;AAbF;IAcI,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,uBAAA;IACA,mBF1FE;IE2FF,wBAAA;IACA,WAAA;IACA,6CAAA;AD6EJ;AACF;AC5EI;EFlDH,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EEiDI,uBAAA;EACA,mBAAA;ADiFN;AChFM;AAJF;IAKI,iBAAA;IACA,cAAA;ADmFN;AACF;AClFM;EACE,oBAAA;EACA,gBAAA;ADoFR;ACnFQ;AAHF;IAII,oBAAA;IACA,kBAAA;ADsFR;AACF;ACrFQ;AAPF;IAQI,SAAA;IACA,+CAAA;ADwFR;ACvFQ;IACE,YAAA;ADyFV;AACF;ACvFQ;EACE,aAAA;ADyFV;ACxFU;AAFF;IAGI,cAAA;AD2FV;AACF;ACxFU;AADF;IAEI,wCAAA;IACA,cAAA;IACA,kBAAA;IACA,kBAAA;AD2FV;AACF;AC1FU;EAEE,cFhIL;AC2NP;ACzFU;EACE,aAAA;AD2FZ;AC1FY;AAFF;IAGI,cAAA;IACA,kBAAA;IACA,QAAA;IACA,8BAAA;IACA,2BAAA;IACA,cAAA;IACA,aFlJL;IEmJK,aAAA;AD6FZ;AACF;AC1FQ;EACE,SAAA;AD4FV;ACvFE;EACE,sBAAA;EFvDF,cApGM;EAqGN,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBALiD;EAMjD,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,sDAAA;ACiJF;ADhJE;EACE,WAAA;EACA,mBAjHG;EAkHH,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,sDAAA;ACkJJ;ADhJE;EACE,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAnII;EAoIJ,YAAA;ACkJJ;ADhJE;EACE,cAnIG;ACqRP;ADjJI;EACE,aArIC;ACwRP;ADjJI;EACE,UAAA;EACA,QAAA;EACA,QAAA;ACmJN;ACpII;AAHF;IAII,uBAAA;ADuIJ;AACF;ACtII;AANF;IAOI,aAAA;ADyIJ;AACF;ACvIE;;EAEE,uDAAA;ADyIJ;ACtIE;;EAEE,UAAA;ADwIJ;ACtIE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;ADwIJ;ACvII;AARF;IASI,wBAAA;AD0IJ;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
